t<script setup>
import { computed } from 'vue';
import FormSwitch from 'v3/components/Form/Switch.vue';

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update']);

const isEnabled = computed({
  get: () => props.value,
  set: value => {
    emit('update', value);
  },
});
</script>

<template>
  <div class="grid items-start grid-cols-12 gap-4">
    <div class="col-span-12 sm:col-span-3">
      <label class="text-sm font-medium leading-6 text-ash-900">
        {{ label }}
      </label>
    </div>

    <div class="col-span-12 sm:col-span-8">
      <div class="flex items-center gap-3">
        <FormSwitch
        class=""
          v-model="isEnabled"
          name="audioToggle"
          @update="isEnabled = $event"
        />
        <span class="text-sm text-ash-600">
          {{ description }}
        </span>
      </div>
    </div>
  </div>
</template>